<h2 class="title">
 {{ 'teams.teamsList.table.topBarActions.addTeam' | translate }}
</h2>
<form [formGroup]="form" (ngSubmit)="create()">
  <div class="image-control-wrapper">
    <mee-image-upload-button
      (uploaded)="logoUploaded($event)"
      [hoverOnPreviewText]="translationMap.get('updateImage')"
      [mediaType]="'TeamsLogo'"
      [preview]="form.controls.LogoUrl.value"
    >
    </mee-image-upload-button>
  </div>

  <div class="branding-wrapper" *ngIf="!isTeamAdmin()">
    <div class="gis-integration-details">
      <mat-slide-toggle class="is-branded" color="primary" formControlName="IsBranded">
        {{ "teams.form.BrandedExtended" | translate }}
      </mat-slide-toggle>
      <p class="branded-description">
        {{ "teams.form.BrandedDescription" | translate }}
      </p>
    </div>
  </div>

  <div class="controls">
    <div class="control-wrapper">
      <mat-form-field>
        <input
          formControlName="CompanySlug"
          type="text"
          [placeholder]="'teams.form.CompanySlug' | translate"
          [required]="true"
          readonly
          matInput
          autocomplete="off"
        />
      </mat-form-field>
    </div>

    <div class="control-wrapper name-wrapper">
      <mat-form-field>
        <input
          matInput
          formControlName="Name"
          name="name"
          placeholder="{{ 'teams.form.Name' | translate }}"
          [required]="true"
        />
        <span matSuffix>{{ form.get("Slug").value }}</span>
        <mat-error
          *ngIf="
                              form.controls.Name.errors &&
                              form.controls.Name.errors.required &&
                              (form.controls.Name.dirty || form.controls.Name.touched)
                            "
        >
          {{ "validation.required" | translate: { name: ("teams.form.Name" | translate) } }}
        </mat-error>
        <mat-error *ngIf="form.controls.Slug.errors && form.controls.Slug.errors.pattern">
          {{ "validation.is_not_valid" | translate: { name: ("teams.form.Name" | translate) } }}
        </mat-error>
      </mat-form-field>
    </div>

    <div class="control-wrapper" *ngIf="isSuperAdmin()">
      <mat-form-field>
        <input
          matInput
          formControlName="Slug"
          name="slug"
          placeholder="{{ 'teams.form.Slug' | translate }}"
          [required]="true"
          [maxLength]="identifierMaxLength"
        />
        <mat-error *ngIf="form.controls.Slug.errors && form.controls.Slug.errors.required &&(form.controls.Slug.dirty || form.controls.Slug.touched)">
          {{ "validation.required" | translate: { name: ("teams.form.Slug" | translate) } }}
        </mat-error>
        <mat-error *ngIf="form.controls.Slug.errors && form.controls.Slug.errors.pattern">
          {{ "validation.is_not_valid" | translate: { name: ("teams.form.Slug" | translate) } }}
        </mat-error>
      </mat-form-field>
    </div>

    <div class="default-coordinates control-wrapper">
      <div class="default-latitude">
        <mat-form-field>
          <input
            matInput
            formControlName="DefaultLatitude"
            name="defaultLatitude"
            placeholder="{{ 'teams.form.DefaultLatitude' | translate }}"
            [required]="true"
          />
          <mat-error *ngIf="isRequiredError('DefaultLatitude')">
            {{ "validation.required" | translate: { name: ("teams.form.DefaultLatitude" | translate) } }}
          </mat-error>
          <mat-error *ngIf="isNotValidError('DefaultLatitude')">
            {{ "validation.is_not_valid" | translate: { name: ("teams.form.DefaultLatitude" | translate) } }}
          </mat-error>
        </mat-form-field>
      </div>

      <div class="default-longitude">
        <mat-form-field>
          <input
            disabled
            matInput
            formControlName="DefaultLongitude"
            name="defaultLongitude"
            placeholder="{{ 'teams.form.DefaultLongitude' | translate }}"
            [required]="true"
          />
          <mat-error *ngIf="this.isRequiredError('DefaultLongitude')">
            {{ "validation.required" | translate: { name: ("teams.form.DefaultLongitude" | translate) } }}
          </mat-error>
          <mat-error *ngIf="isNotValidError('DefaultLongitude')">
            {{ "validation.is_not_valid" | translate: { name: ("teams.form.DefaultLongitude" | translate) } }}
          </mat-error>
        </mat-form-field>
      </div>
    </div>
  </div>
  <div class="actions-wrapper">
    <button class="cancel-button" (click)="cancel()"
            type="button">{{ 'global-forms.cancel' | translate }}</button>
    <button mat-raised-button
            color="primary" class="apply-button" type="submit" [disabled]="(!form.dirty && !isLogoTouched) || form.invalid || (loadingService.isLoading$() | async)">
      {{ 'system.save' | translate }}
    </button>
  </div>
</form>
